<template>
  <div id="app">
    <!-- 全局 loading 指示器 — 显眼但非阻塞 -->
    <global-loading />
    <!-- <keep-alive> -->
    <router-view />
    <!-- </keep-alive> -->
  </div>
</template>

<script>
import { resize } from "@/assets/js/index";
import GlobalLoading from "@/components/GlobalLoading";
export default {
  name: "App",
  components: { GlobalLoading },
  mounted() {
    resize();
    window.addEventListener("resize", resize, false);
  },
};
</script>

<style>
.el-table th.gutter {
  display: table-cell !important;
}
.el-table--border th.gutter:last-of-type {
  display: block !important;
}
.el-table {
  overflow: auto;
}
.el-table__header-wrapper,
.el-table__body-wrapper,
.el-table__footer-wrapper {
  /* overflow: visible; */
}
.el-table__body-wrapper {
  overflow-x: visible !important;
}
/* 这个是为了解决前面样式覆盖之后伪类带出来的竖线 */
.el-table::after {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue